<template>
    <section class="category">
        <SubpageHeader :pageId="pageId" :pageType="pageType" v-if="pageId && pageType"></SubpageHeader>
        <CategoryWebsite v-if="pageType === 'CATEGORY_WEBSITE'" :pageId="pageId" :pageType="pageType" :name="name"></CategoryWebsite>
        <CategoryAudio v-if="pageType === 'CATEGORY_AUDIO'" :pageId="pageId" :pageType="pageType" :name="name"></CategoryAudio>
        <CategoryGame v-if="pageType === 'CATEGORY_GAME'" :pageId="pageId" :pageType="pageType" :name="name"></CategoryGame>
        <CategoryStream v-if="pageType === 'CATEGORY_STREAM'" :pageId="pageId" :name="name"></CategoryStream>
        <CategorySleep v-if="pageType === 'CATEGORY_SLEEP'" :pageId="pageId" :pageType="pageType" :name="name"></CategorySleep>
    </section>
</template>

<script>
import SubpageHeader from "../elements/SubpageHeader.vue";
import CategoryWebsite from "./CategoryWebsite.vue";
import CategoryGame from "./CategoryGame.vue";
import CategoryAudio from "./CategoryAudio.vue";
import CategoryStream from "./CategoryStream.vue";
import CategorySleep from "./CategorySleep.vue";

export default {
    name: "Category",
    components: {
        SubpageHeader,
        CategoryWebsite,
        CategoryAudio,
        CategoryGame,
        CategoryStream,
        CategorySleep
    },
    props: {
        type: {
            type: String,
        }
    },
    computed: {
        path() {
            if(this.$route && this.$route.path) {
                return this.$route.path
            }
            return null;
        },
        name() {
            if(this.$route && this.$route.name) {
                return this.$route.name
            }
            return null;
        },
        pageType() {
            if(this.type) {
                return this.type;
            }
            else if(this.$route.params.type) {
                return this.$route.params.type;
            } else {
                return window.__pageSettings.type;
            }
        },
        history() {
            return this.$store.getters.getHistory;
        },        
        pageId() {
            if(this.$route.params.id) {
                return parseInt(this.$route.params.id);
            } else {
                if(this.history.some(el => el.path === this.path)) {
                    return this.history.find(el => el.path === this.path).id;
                } else {
                    return window.__pageSettings.id;
                }
            }
        }
    }
}
</script>
